import { Info } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip'

interface InfoTipProps {
  content: React.ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
}

/**
 * A small inline ⓘ icon that shows a rich tooltip on hover.
 * Wrap in a flex container alongside the label it annotates.
 */
export function InfoTip({ content, side = 'top' }: InfoTipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-default text-muted-foreground/60 hover:text-muted-foreground transition-colors shrink-0">
          <Info className="h-3.5 w-3.5" />
        </span>
      </TooltipTrigger>
      <TooltipContent side={side} className="leading-relaxed max-w-xs">
        {content}
      </TooltipContent>
    </Tooltip>
  )
}
